import { isWebPlatform } from '@eventbrite/checkout-postmessage-api';
import { joinPath } from '@eventbrite/path-utils';
import { replace } from 'react-router-redux';
import { ThunkAction } from 'redux-thunk';
import { BASE_URL, PURCHASE_CONFIRMATION_PATH } from '../constants';
import { isEventbriteTLD as getIsEventbriteTLD } from '../selectors/app';
import { isOrganizerInitiatedTransferOrder } from '../selectors/order';
import {
    getRedirectUrlFromTicketBuyerSettings,
    isAddAttendeesOrder,
} from '../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../state';
import {
    notifyParentOrderStatusPlaced,
    notifyParentProtectCheckout,
} from './notifyParent';
import { completeOrderActions } from './order/common';

export const showPurchaseConfirmation =
    (): ThunkAction<Promise<void>, CheckoutState, void> =>
    async (dispatch, getState) => {
        const state = getState();

        const isEventbriteTLD = getIsEventbriteTLD(state);
        const redirectUrl = getRedirectUrlFromTicketBuyerSettings(state);

        await dispatch(completeOrderActions());

        if (isEventbriteTLD && redirectUrl) {
            dispatch(notifyParentProtectCheckout({ disable: true }));
        }

        // In Add Attendees and in transfers initiated by the organizer,
        // the confirmation is handled by the iframe container.
        if (
            isAddAttendeesOrder(state) ||
            isOrganizerInitiatedTransferOrder(state)
        ) {
            return null;
        }

        return dispatch(
            replace(joinPath(BASE_URL, PURCHASE_CONFIRMATION_PATH)),
        );
    };

export const showOrderConfirmation: ThunkAction<
    Promise<void>,
    CheckoutState,
    void
> = async (dispatch) => {
    const platform = dispatch(notifyParentOrderStatusPlaced());

    if (platform && isWebPlatform(platform)) {
        await dispatch(showPurchaseConfirmation());
    }
};
